export default __webpack_public_path__ + "static/media/theme_irland.ab959bed.jpg";